"use client";
import { FeedPostFooter } from "../FeedPostFooter";
import { FeedPostDtoWithOgMetadata } from "@/api/posts/types";
import { FeedPostArtOrderContent } from "../FeedPostArtOrderContent";
import { ArtOrderPostCommentsList } from "../../Comments/CommentsList/ArtOrderPost";

export interface Props {
  feedPost: FeedPostDtoWithOgMetadata;
}

export default function FeedArtOrderPost({ feedPost }: Props) {
  return (
    <li className="pb-4 md:pb-6 border-b border-opacityGray-300 list-none last-of-type:border-b-0">
      <FeedPostArtOrderContent feedPost={feedPost} />
      <FeedPostFooter feedPost={feedPost} disableComment />
      <ArtOrderPostCommentsList artOrder={feedPost.artOrder!} />
    </li>
  );
}
